import React, { Component } from "react";
import { GenericModal } from 'com-gyf-webcore-userinterfacecomponents';


let evento = {
    identifier: '',
    checked: '',
    value:''
};
class CheckBoxSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isChecked: this.props.isChecked,
            identifier: this.props.identifier,
            message: this.props.message,
            subMessage: this.props.subMessage,
            value: this.props.value,
            extencion: this.props.extencion
        }
    }
    
    componentWillReceiveProps(nextProps) {
        this.setState({ isChecked: nextProps.isChecked, value: nextProps.value });
    }

    onAdvertirVinculacion(event) {
        evento.identifier = this.state.identifier;
        evento.checked = event.target.checked;
        evento.value = event.target.value;
        if (event.target.id == 'vincularGrupoWindows') {
            if (this.state.isChecked) {
                this.onHandleCheckChange();
            } else {
                $("#modal-vinculacion-grupos").modal({ backdrop: "static" });
            }
        } else {
            this.onHandleCheckChange();
        }
    }

    onHandleCheckChange() {
        let identifier = evento.identifier;
        let checked = evento.checked;
        let value = evento.value;

        this.props.checkboxChangeState({ identifier: identifier, checked: checked, value: value});
        this.setState({ isChecked: checked });

        if (!checked && value)
            this.setState({ value: 0 });

        $("#modal-vinculacion-grupos").modal('hide');
    }

    onHandleValueChange(event) {
        let identifier = this.state.identifier;
        let value = event.target.value;

        this.props.textChangeState({ identifier: identifier, value: value });

        this.setState({ value: value });
    }

    render() {
        return (
            <div>

                <table className="col-md-12 configuracion-edit-table">
                    <tbody>
                        <tr >
                            <td className="col-md-7">
                            <div className="checkbox-container-edit">

                                    <input type="checkbox" id={this.state.identifier} checked={this.state.isChecked} onClick={(event) => this.onAdvertirVinculacion(event)}></input>
                                <label htmlFor={this.state.identifier}>{this.state.message}</label>

                                {this.state.subMessage &&
                                    <p>{this.state.subMessage}</p>}
                            </div>
                        </td>

                         <td className="col-md-2">
                            <div className="configuracion-view-extencion">
                                <div className="form-group">
                                    {(this.state.isChecked && this.state.extencion) ?
                                            (<input type="text" className="form-control default-input" onChange={(event) => this.onHandleValueChange(event)} value={this.state.value}></input>)
                                        : null}
                                </div>
                            </div>
                        </td>

                         <td className="col-md-2">
                            <div className="configuracion-view-extencion">
                                <div className="form-group">
                                    {(this.state.isChecked && this.state.extencion) ?
                                            (<p>&nbsp;{this.state.extencion}</p>)
                                        : null}
                                </div>             
                            </div>
                          </td>
                        </tr>
                    </tbody>
                </table>

                <GenericModal id="modal-vinculacion-grupos"
                    className="modal fade-out modal-center"
                    type="ALL_CUSTOM"
                    screenSize="modal-dialog modal-generic"
                    header={<h2>Advertencia</h2>}
                    footer={<div className="row">
                        <div className="col-xs-4">
                            <button type="button" className="btn btn-cta" onClick={() => this.onHandleCheckChange()}>Si</button>
                        </div>
                        <div className="col-xs-4">
                            <button type="button" style={{ minWidth: '110px' }} className="btn btn-secondary" data-dismiss="modal">No</button>
                        </div>
                    </div>}
                    body={<p>Si desea activar la Vinculación de Perfiles con Grupo de Windows, recuerde que antes, debe tener vinculaciones asignadas de lo contrario no podra hacer login exitosamente. ¿Desea continuar?</p>}
                />

            </div>
        );
    }
}

export default CheckBoxSection; 


/*

                <div className="col-md-1">
                    <div className="form-group">
                        {(this.state.isChecked && this.state.extencion) ?
                            (<input type="text" className="form-control" onChange={(event) => this.onHandleValueChange(event)} value={this.state.value}></input>)
                            : null}
                    </div>
                </div>

                <div className="col-md-2">
                    <div className="form-group">
                        {(this.state.isChecked && this.state.extencion) ?
                            (<p>{this.state.extencion}</p>)
                            :null}
                    </div>
                </div>

*/